import { useLayoutEffect, useEffect, useContext } from "react";
import { MediaGraphicLine } from "./MediaGraphicLine";
import { MediaGraphicPie } from "./MediaGraphicPie";
import { SelectTypeGridEnum } from "../../../utils/enums";
import { AudienceContext } from "../../../context/AudienceContext";
export function MediaGraphic({
  heading,
  lastAudience,
  data,
  Indice,
  selectTypeGrid,
  divMinute,
  audienceMediaFirstTable
}) {
  const { doAudienceMedia } = useContext(AudienceContext);

  useLayoutEffect(() => { }, []);
  useEffect(() => { }, []);

  useEffect(() => {
    if (selectTypeGrid === SelectTypeGridEnum.Minute)
      doAudienceMedia();
  }, [selectTypeGrid]);

  const contentGraphic =
    Indice === 0 || Indice === 3 || Indice === 4 ? (

      <MediaGraphicLine
        heading={heading}
        lastAudience={lastAudience}
        data={data}
        divMinute={divMinute}
        audienceMediaFirstTable={audienceMediaFirstTable}

      />
    ) : (
      <MediaGraphicPie
        heading={heading}
        lastAudience={lastAudience}
        data={data}
        divMinute={divMinute}
        audienceMediaFirstTable={audienceMediaFirstTable}
      />
    );

  return (
    <div
      id="MediaGraphic"
      data-testid="MediaGraphic"
      style={{
        display: "block",
      }}
    >
      {contentGraphic}
    </div>
  );
}


